import React from 'react';
import { Target, BarChart3, CheckCircle2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { mockServices } from '../mock';

const iconMap = {
  Target: Target,
  BarChart3: BarChart3
};

const Services = () => {
  return (
    <section id="services" className="py-32 bg-white relative">
      {/* Top separator */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-20 animate-fade-in">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-orange-500 via-pink-500 to-purple-600 bg-clip-text text-transparent">
              Nos Services
            </span>
          </h2>
          <p className="text-xl text-gray-600">
            Des solutions digitales complètes pour propulser votre entreprise vers le succès
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {mockServices.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-500 border-2 hover:border-orange-200 transform hover:-translate-y-2 animate-fade-in bg-white"
                style={{ animationDelay: `${index * 200}ms` }}
              >
                <CardHeader className="pb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-pink-500 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <CardTitle className="text-2xl font-bold text-gray-900 group-hover:text-orange-600 transition-colors">
                    {service.title}
                  </CardTitle>
                  <CardDescription className="text-lg text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardHeader>
                <CardContent className="pt-4">
                  <ul className="space-y-3">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start space-x-3 group/item">
                        <CheckCircle2 className="w-5 h-5 text-green-500 mt-0.5 group-hover/item:scale-110 transition-transform" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  
                  <button className="mt-6 w-full py-3 bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300">
                    En savoir plus
                  </button>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Service Image */}
        <div className="mt-20 max-w-5xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://images.unsplash.com/photo-1686061593269-420785fb8fa0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwc3RyYXRlZ3l8ZW58MHx8fHwxNzcxMzYzNjU2fDA&ixlib=rb-4.1.0&q=85"
              alt="Analytics Dashboard"
              className="w-full h-80 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-orange-600/90 to-pink-600/90 flex items-center justify-center">
              <div className="text-center text-white px-6">
                <h3 className="text-3xl font-bold mb-4">Prêt à transformer votre stratégie digitale ?</h3>
                <p className="text-xl mb-6">Discutons de vos objectifs et trouvons les solutions adaptées</p>
                <button
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="bg-white text-orange-600 hover:bg-gray-100 font-bold py-3 px-8 rounded-lg shadow-xl transform hover:scale-105 transition-all duration-300"
                >
                  Contactez-nous
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom separator */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent"></div>
    </section>
  );
};

export default Services;
